<div class="social-icons" [class.no-bottom-padding]="data && data['brand_key'] === 'cb'">
  <div (click)="goTo(link.url)" *ngFor="let link of brandGroup" class="icon d-flex align-items-center">
    <img [src]="link.iconPath" alt="" />
  </div>
</div>
